import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";
import AppContext from "../../AppContext";
import XTime from "../kids/XTime";
import MenuTable from "../../helpers/MenuTable";
import ScheduleNew from "./ScheduleNew";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import InputCombo from "../../helpers/InputCombo";



function Schedule(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        p_imie_nazwisko: '',       
        rok: (new Date()).getFullYear() ,
        miesiac: (new Date() ).getMonth()+1,   
        archiwalny: '0',
        show: true,           
    });
    const [tab, setTab] = useState(null);    
    const [selectedRow, setSelectedRow] = useState([]);


    const tabRefPDF = useRef(0);
    const tabRefCSVPrint = useRef(0);

    const tab2RefPDF = useRef(0);
    const tab2RefCSVPrint = useRef(0);


    const tabCalRef = useRef(0);
    


    const [itemSelected, setItemSelected] = useState(1);

    const clickTab = (e) => {

        var t = e.target.getAttribute("atr-tab");
        setItemSelected(t);
    }




    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }


    const filterClear = () => {
        setFilterParam({
            p_imie_nazwisko: '',            
            rok: (new Date()).getFullYear() ,
            miesiac: (new Date() ).getMonth()+1,                    
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }


    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
 
         setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
         
         if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

         props.mainView.writeFilter(filedName, val);
     }



     const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }




    

    //-------------------------------------------------------
//-------------------------------------------------------
//MASS
const changeSelected = (e) => {

    var id    = e.target.getAttribute('atr-id');   
    var selected = 0;

    if(e.target.checked) selected = 1;

    for(var k=0; k<selectedRow.length; k++)
    {
        if(selectedRow[k].id == id)  selectedRow[k].selected = selected;
    }

    setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
}

const changeSelectedAll = (e) => {

    var s = selectedRow[0].selected;
    if(s == 1) {  s = 0; } else s = 1;

    for(var k=0; k<selectedRow.length; k++)
        {
          selectedRow[k].selected = s;
        }
    
        setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 

}


//--------------------------------------------
//--------------------------------------------
//--------------------------------------------



    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_emps,schedule', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);       
                        
                        
                        var newSelector = [];

                        res.result.tab.forEach( (item) => {
                            newSelector.push({
                                id: item.id,
                                title: item.dzien + " ("+item.p.imie + " " + item.p.nazwisko +")",                           
                                selected: 0,                              
                            });
                            
                        } )

                        setSelectedRow(newSelector);

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }






    const clickOnDay = (e) => {

        var date = e.target.getAttribute('date');
        var title = e.target.getAttribute('title');

        console.log("Calendar " + date + " " + title);

         
    }




    const onChangeXTime = (hm, param1, param2, param3, param4) =>  {

        //console.log("XTime ", hm, param1, param2, param3, param4);
 

        props.mainView.setProgress(-2);

       
        var req = {
            id: param1,
            hm: hm,
            typ: param2
        };


        fetch( Config.url + '/rest_v1_emps,schedule_hour_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane" , "ok" , null );
                        getTab();
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });


    }



    const goDeleteOK = (id) => {
       
 
        props.mainView.setProgress(-2);

        var req = {
            id:id
        };

        fetch( Config.url + '/rest_v1_emps,schedule_del', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Pozycja została usunięta" , "ok" , null);  
                       getTab();  
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const goDelete = (e) => {

        var id = e.target.getAttribute("id");

        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć wybraną pozycje?", "yesno", (option)=>{
          
                        ///--------
                        if(option == "yes") goDeleteOK(id);
                        //--------
        } );
    }




    const goCancel = (e) =>
        {         
            var ids = new Array();
        
            for(var k=0; k<selectedRow.length; k++)
                {
                   if( selectedRow[k].selected == 1)
                   {
                        ids.push({
                            id: selectedRow[k].id,
                            title: selectedRow[k].title
                        });
                   }
                }
            
        
             if(ids.length < 1)     
             {       
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnej pozycji' ,  "ok"  ,null); 
                return;              
             }
        
        
            props.mainView.showDialog("Potwierdź", "Na pewno chcesz usunąć wybrane godziny pracy?", "yesno", (option)=>{
                  
                ///--------
                if(option == "yes")
                {
                            props.mainView.setProgress(-2);
        
                            var req = {
                                ids: ids,                            
                            }
        
                            fetch( Config.url + '/rest_v1_emps,schedule_del_mas', {
                                method: 'POST', 
                                body: JSON.stringify(req), 
                                headers: {
                                    'Content-Type': 'application/json',                    
                                    'X-Api-Key': props.userData.apiKey,
                                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                                    '_sec_key_': Config.genXKey() ,
                                }
                            })
                            .then(res => res.json() )
                            .then(res => { 
        
                                        props.mainView.setProgress(-1);        
                                        if(res._sys_ == undefined)
                                        {
                                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                        }else
                                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                        {
                                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                        }else    
                                        {      
                                            props.mainView.showDialog( "Sukces", "Usunięto pozycji: " + res.result , "ok" , null);                               
                                            getTab();            
                                        }
                            } )
                            .catch(err => {          
                                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                        props.mainView.setProgress(-1);
                            });
                }//koniec yes
                //--------
            } );
        
        }  




    const onClickFree = (e) => {        

        var gTitle    =  e.target.getAttribute("atr-title"); 

        props.mainView.showDialog("eLizak", gTitle , "ok", (option)=>{
          
            ///--------
      
            //--------
            } );

    }

    const onClickTime = (e) => {

        //    atr-id={grf.id} atr-date={px.date} atr-start={grf.od} atr-end={grf.do}  atr-title={tt.nazwisko + " " + tt.imie + " " + px.date } onClick={onClickTime} 

           var gId       =  e.target.getAttribute("atr-id"); 
           var gDay      =  e.target.getAttribute("atr-date"); 
           var gStart    =  e.target.getAttribute("atr-start"); 
           var gEnd      =  e.target.getAttribute("atr-end"); 
           var gTitle    =  e.target.getAttribute("atr-title"); 

         //  alert(gId + " " + gTitle + " | " + gStart + " | " + gEnd);


           props.mainView.showDialog("eLizak", gTitle + " ("+gStart+" / "+gEnd+") ", "ok", (option)=>{
          
            ///--------
      
            //--------
            } );

    }



    if(tab == null)
        {
            setTab([]);
            getTab();
         
    
            return <div>
                ...
            </div>
        }

    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);           
        }





        var zaznaczonych = 0;
        var arrSelected = new Array();         
        for(var s=0; s<selectedRow.length; s++)
        {
            if(selectedRow[s].selected == 1) 
            {
                zaznaczonych ++;
                arrSelected.push( selectedRow[s] );                    
            }
        }

        




 
    
        var d = new Date(filterParam.rok  ,  filterParam.miesiac , 0);
        var lastDay = d.getDate();

        d = new Date(filterParam.rok  ,  filterParam.miesiac-1 , 1);
        var dayWeek =  d.getDay();

        //console.log("DDDDDD", dayWeek, d );
        
        var calD = [
            [' ',' ',' ',' ',' ',' ',' '],
            [' ',' ',' ',' ',' ',' ',' '],
            [' ',' ',' ',' ',' ',' ',' '],
            [' ',' ',' ',' ',' ',' ',' '],
            [' ',' ',' ',' ',' ',' ',' '],
            [' ',' ',' ',' ',' ',' ',' '],
        ];
    
        var dayX = 0;
    
        for(var row=0; row<calD.length; row++)
        {
            for(var dd=0; dd<7; dd++)
            {
                if(dayX > lastDay) break;
                if(dd == 0 && dayWeek ==1 && dayX==0 ) {dayX = 1;}else
                if(dd == 1 && dayWeek ==2 && dayX==0 ) {dayX = 1;}else
                if(dd == 2 && dayWeek ==3 && dayX==0 ) {dayX = 1;}else
                if(dd == 3 && dayWeek ==4 && dayX==0 ) {dayX = 1;}else
                if(dd == 4 && dayWeek ==5 && dayX==0 ) {dayX = 1;}else
                if(dd == 5 && dayWeek ==6 && dayX==0 ) {dayX = 1;}else 
                if(dd == 6 && dayWeek ==0 && dayX==0 ) {dayX = 1;}else {}
    
                
                
                if(dayX == 0)
                {
                    calD[row][dd] = {
                        date: '',
                        day: '',
                        title: '',
                        dw: '',
                        rows: []
                    }; 
                }else
                {
    
                    var strM = filterParam.miesiac+"";
                    if(strM.length == 1) strM = "0" + strM;
    
                    var strD = dayX+"";
                    if(strD.length == 1) strD = "0" + strD;
    
                    var dateX  = filterParam.rok+"-"+strM+"-"+strD;             
              
                    var p = []; //

                  

                   if(tab.cal != undefined)
                   {
                        for(var kk=0; kk < tab.cal.length ; kk++)
                        {
                        
                            if(tab.cal[kk].data == dateX)
                            {
                                p = tab.cal[kk].p;
                                break;
                            }
                        }
                   }



    
                    calD[row][dd] = {
                        date: dateX,
                        day: dayX,
                        title: 'Pokaż',
                        dw: dd,
                        className: "",
                        rows: p,
                    }; 
                }
    
                if(dayX>0)
                dayX++;
            }
        }

        if(calD[5][0] == ' ') {
            calD = calD.slice(0, -1);
        }
    
    
        var monthName = "";
        if(filterParam.miesiac == 1) monthName = "Styczeń";
        if(filterParam.miesiac == 2) monthName = "Luty";
        if(filterParam.miesiac == 3) monthName = "Marzec";
        if(filterParam.miesiac == 4) monthName = "Kwiecień";
        if(filterParam.miesiac == 5) monthName = "Maj";
        if(filterParam.miesiac == 6) monthName = "Czerwiec";
        if(filterParam.miesiac == 7) monthName = "Lipiec";
        if(filterParam.miesiac == 8) monthName = "Sierpień";
        if(filterParam.miesiac == 9) monthName = "Wrzesień";
        if(filterParam.miesiac == 10) monthName = "Październik";
        if(filterParam.miesiac == 11) monthName = "Listopad";
        if(filterParam.miesiac == 12) monthName = "Grudzień";
    

        

        var cssTab1 = "";
        var cssTab2 = "";
        var cssTab3 = "";
        var cssTab4 = "";
        var cssTab5 = "";
        var cssTab6 = "";
    
        if(itemSelected == 1) cssTab1 = " xActive ";
        if(itemSelected == 2) cssTab2 = " xActive ";
        if(itemSelected == 3) cssTab3 = " xActive ";
        if(itemSelected == 4) cssTab4 = " xActive ";
        if(itemSelected == 5) cssTab5 = " xActive ";
        if(itemSelected == 6) cssTab6 = " xActive ";




    return  <div className="view_content">
         

         <div className="table_filter">
               
                      
                     

                <div className="filter_controll">   
                    <label>Rok: </label>                             
                    <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={filterParam.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                </div> 

                <div className="filter_controll">   
                    <label>Miesiąc: </label>                             
                    <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}  value={filterParam.miesiac}   valChange={valChangeListener} goNext={goNextNew} name="miesiac" placeholder={": "}  noempty="1"   />
                </div> 


                <div className="filter_btn">
                   
                    <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                </div>

        </div>


        <div className="table_widget">
             <ScheduleNew userData={props.userData} mainView={props.mainView}  onSuccess={getTab} />
        </div>



        <div className="xTabs">
                        <div className={"xItem " + cssTab1 } atr-tab="1" onClick={clickTab}  >Podgląd</div>
                        <div className={"xItem " + cssTab2 } atr-tab="2" onClick={clickTab}  >Lista dni</div>                                 
                        <div className={"xEmpty "  }>&nbsp;</div>
                </div>

        <br/>


        {
            itemSelected == 1 &&
            <div className=" bg_center">

                            <div className="table_widget">
                                <HtmlToPDF tabRef={tabCalRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title="Grafik" />
                            </div>


                            <div className="gohide"  ref={tabCalRef}>

                                    <h3>Grafik na {filterParam.rok + "-" + filterParam.miesiac }</h3>   


                                            <div className="calSchedule "  >
                                            <table className="schedTab" >                                       
                                                <tr className="days">                                               
                                                    <td className="gocenter gobold">PN</td>
                                                    <td className="gocenter gobold">WT</td>
                                                    <td className="gocenter gobold">ŚR</td>
                                                    <td className="gocenter gobold">CZ</td>
                                                    <td className="gocenter gobold">PT</td>
                                                    <td className="gohide gobold">SB</td>
                                                    <td className="gohide gobold">ND</td>
                                                </tr>

                                                {
                                                    calD.map( (week, ixWeek) => {
                                                        return (
                                                                <tr className="dinside">

                                                                   
                                                                        {
                                                                            week.map( (px, inxDay) => {


                                                                                var classTD = "";

                                                                                //if(px.dw == 5 || px.dw== 6) classTD = " cweek "
                                                                                if(px.dw == 5 || px.dw== 6 || inxDay == 6 || inxDay == 5) classTD = " cweek gohide"

                                                                                classTD = classTD + " " + px.className;

                                                                                return (                                                                            
                                                                                    <td className={"clink w7day  " + classTD}  >
                                                                                    <div className="tdr" title={px.title} date={px.date} onClick={clickOnDay}>&nbsp;{px.day}.</div>
                                                                                    <br/>

        
                                                                                    {
                                                                                            px.rows != undefined &&
                                                                                            px.rows.map( (tt, ttInx) => {
                                                                                            

                                                                                                    return <div className="labBar">
                                                                                                              
                                                                                                            
                                                                                                                {
                                                                                                                    tt.grafik.map( (grf, grfInx) => {

                                                                                                                        return <div style={{fontSize: "10px"}}>
                                                                                                                             &nbsp; {tt.info.imie + " " + tt.info.nazwisko + ", " + grf.od + " - " + grf.do }
                                                                                                                        </div>
 
                                                                                                                    } )
                                                                                                                }
                                                                                                            </div>
                                                                                            } )
                                                                                    } 
                                                                                    

                                                                                    </td>
                                                                                )
                                                                            } )
                                                                        }
                                                                </tr>
                                                        )
                                                    } )
                                                }

                                            </table>
                                        </div>

                            </div>






                            <div className="calSchedule "  >
                                    <table className="schedTab" >                                       
                                        <tr className="days">
                                            <td className="gocenter">&nbsp;</td>
                                            <td className="gocenter">PN</td>
                                            <td className="gocenter">WT</td>
                                            <td className="gocenter">ŚR</td>
                                            <td className="gocenter">CZ</td>
                                            <td className="gocenter">PT</td>
                                            <td className="gohide">SB</td>
                                            <td className="gohide">ND</td>
                                        </tr>

                                        {
                                            calD.map( (week, ixWeek) => {
                                                return (
                                                        <tr className="dinside">

                                                            <td className="gocenter timeView">
                                                                06:00
                                                                <br/>
                                                                <br/>
                                                                   &nbsp;
                                                                <br/>
                                                                <br/>
                                                                18:00
                                                            </td>
                                                                {
                                                                    week.map( (px, inxDay) => {


                                                                        var classTD = "";

                                                                        //if(px.dw == 5 || px.dw== 6) classTD = " cweek "
                                                                        if(px.dw == 5 || px.dw== 6 || inxDay == 6 || inxDay == 5) classTD = " cweek gohide"

                                                                        classTD = classTD + " " + px.className;

                                                                        return (                                                                            
                                                                            <td className={"clink w7day  " + classTD}  >
                                                                              <div className="tdr" title={px.title} date={px.date} onClick={clickOnDay}>
                                                                                {px.day}.&nbsp; 


                                                                                {
                                                                                    tab.nb != undefined &&
                                                                                    <Fragment>

                                                                                            {
                                                                                                tab.nb.map( (u, uInx) => {

                                                                                                    if( u.dzien != px.date) return null;

                                                                                                    return <div  atr-title={  u.imie + " " + u.nazwisko + ", " + u.nazwa }   onClick={onClickFree}  className="schedule_free" style={{backgroundColor: u.kolor }} title={ u.imie + " " + u.nazwisko + ", urlop: " + u.nazwa } >
                                                                                                        {u.skr}
                                                                                                        </div>

                                                                                                })
                                                                                            }

                                                                                    </Fragment>
                                                                                }

                                                                              </div>
 
                                                                               {
                                                                                    px.rows != undefined &&
                                                                                    px.rows.map( (tt, ttInx) => {
                                                                                       

                                                                                            return <div className="labBar">
                                                                                                        {tt.info.in }
                                                                                                       
                                                                                                        {
                                                                                                            tt.grafik.map( (grf, grfInx) => {

                                                                                                                var minToOnePix = 0.08333; 

                                                                                                                var startMin = grf.od_min;
                                                                                                                var stopMin  = grf.do_min;

                                                                                                                var minDiff = stopMin - startMin;
                                                                                                                if(minDiff < 0) minDiff = 0;

                                                                                                                minDiff += 360;
 

                                                                                                                var minOd6 = startMin - 360;
                                                                                                                if(minOd6 < 0) minOd6 = 0;

                                                                                                                var marginTopPix = parseInt( minOd6 * minToOnePix);

                                                                                                                var heightPix = minDiff * minToOnePix;
                                                                                                                heightPix -= marginTopPix;
                                                                                                                
                                                                                                                heightPix = parseInt(heightPix);

                                                                                                                var sum = heightPix + marginTopPix;
                                                                                                                if(sum > 60) heightPix -= marginTopPix;

                                                                                                                var bgC = grf.kolor;

                                                                                                        

                                                                                                                return <div    atr-id={grf.id} atr-date={px.date} atr-start={grf.od} atr-end={grf.do}  atr-title={tt.info.nazwisko + " " + tt.info.imie + ", " + px.date } onClick={onClickTime}        title={ tt.info.imie + " " + tt.info.nazwisko +  ", Od " + grf.od + " do " + grf.do} className="timeBar" style={{marginTop:marginTopPix+"px", height: heightPix+"px", backgroundColor: bgC }}  >
                                                                                                                    &nbsp;
                                                                                                                </div>
                                                                                                            } )
                                                                                                        }
                                                                                                    </div>
                                                                                    } )
                                                                               } 
                                                                            

                                                                            </td>
                                                                        )
                                                                    } )
                                                                }
                                                        </tr>
                                                )
                                            } )
                                        }

                                    </table>
                                </div>

           </div>
        }

        
        {
            itemSelected == 2 &&
            <div className=" bg_center">


                <div className="table_widget">

                <HtmlToPDF tabRef={tabRefPDF} userData={props.userData} mainView={props.mainView}  orientation="landscape" title="Rejestr" />   
                <Csv tabRef={tabRefCSVPrint} />
                <Print tabRef={tabRefCSVPrint} />

                </div>

                <div className="table_mass">  
                       <div className="title_mass">Operacje masowe (zaznaczono: {zaznaczonych}) </div>
                       &nbsp;                    
                       <span className="btn" onClick={goCancel}  >Usuń</span>
                </div>




                <div ref={tabRefPDF} className="gohide">

                     <h3>Grafik {filterParam.rok + "-" + filterParam.miesiac }</h3>   

                     <table className="table" ref={tabRefCSVPrint} >                        
                        <thead>
                             <tr className="header">                              
                                 <td className="gocenter">LP</td>     
                                 <td>Dzień</td>        
                                 <td>Osoba</td>        
                                 <td>Od godziny</td>        
                                 <td>Do godziny</td>        
                                 <td className="td_right">Ilość godzin</td>                              
                             </tr>
                        </thead>
                        <tbody>

                            {
                                tab.tab != undefined &&
                                <Fragment>

                                        {
                                            tab.tab.map( (row, inx) => {

                                                var rowStyle = " row ";
                                                if(inx % 2 == 0 )rowStyle = " row2 ";

                                                var isChecked = "";

                                                for(var s=0; s<selectedRow.length; s++)
                                                    {
                                                        if( selectedRow[s].id == row.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                    }
            
                                                return <tr key={inx} className={rowStyle}>
                                                           
            
                                                            <td className="gocenter">LP</td>     
                                                            <td className="gocenter">{row.dzien}</td>        
                                                            <td>{row.p.nazwisko + " " + row.p.imie}</td>        
                                                            <td className="gocenter">                                                            
                                                                <XTime title={ row.p.imie + " " + row.p.nazwisko + " - " + row.dzien } hour={ row.godzina.substring(0,2) } minute={ row.godzina.substring(3,5) }  onChange={onChangeXTime} param1={row.id} param2={"start"}  param3='' param4='' />
                                                            </td>        
                                                            <td className="gocenter">                                                   
                                                                <XTime title={ row.p.imie + " " + row.p.nazwisko + " - " + row.dzien } hour={ row.godzina_koniec.substring(0,2) } minute={ row.godzina_koniec.substring(3,5) }  onChange={onChangeXTime} param1={row.id} param2={"end"}  param3='' param4='' />
                                                            </td>        
                                                            <td className="gocenter">{row.czas}</td>                                                          
                                                        </tr>
            
                                            } )
                                        }

                                </Fragment>                                
                            }


                        </tbody>
                    </table>

                </div>

                
                <table className="table">                        
                        <thead>
                             <tr className="header">
                                <td className="link_normal td_left" onClick={changeSelectedAll}>Z</td>      
                                 <td className="gocenter">LP</td>     
                                 <td>Dzień</td>        
                                 <td>Osoba</td>        
                                 <td>Od godziny</td>        
                                 <td>Do godziny</td>        
                                 <td className="td_right">Ilość godzin</td>
                                 <td className="td_option"></td>
                             </tr>
                        </thead>
                        <tbody>

                            {
                                tab.tab != undefined &&
                                <Fragment>

                                        {
                                            tab.tab.map( (row, inx) => {

                                                var rowStyle = " row ";
                                                if(inx % 2 == 0 )rowStyle = " row2 ";

                                                var isChecked = "";

                                                for(var s=0; s<selectedRow.length; s++)
                                                    {
                                                        if( selectedRow[s].id == row.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                    }
            
                                                return <tr key={inx} className={rowStyle}>

                                                            <td className="gocenter">
                                                                <input type="checkbox" atr-id={row.id} onChange={changeSelected} checked={isChecked} />
                                                            </td> 
            
                                                            <td className="gocenter">{inx+1}</td>     
                                                            <td className="gocenter">{row.dzien}</td>        
                                                            <td>{row.p.nazwisko + " " + row.p.imie}</td>        
                                                            <td className="gocenter">                                                            
                                                                <XTime title={ row.p.imie + " " + row.p.nazwisko + " - " + row.dzien } hour={ row.godzina.substring(0,2) } minute={ row.godzina.substring(3,5) }  onChange={onChangeXTime} param1={row.id} param2={"start"}  param3='' param4='' />
                                                            </td>        
                                                            <td className="gocenter">                                                   
                                                                <XTime title={ row.p.imie + " " + row.p.nazwisko + " - " + row.dzien } hour={ row.godzina_koniec.substring(0,2) } minute={ row.godzina_koniec.substring(3,5) }  onChange={onChangeXTime} param1={row.id} param2={"end"}  param3='' param4='' />
                                                            </td>        
                                                            <td className="gocenter">{row.czas}</td>
                                                            <MenuTable>
                                                                <ul>
                                                                       <li onClick={goDelete} v="delete" id={row.id} >usuń</li>
                                                                </ul>
                                                            </MenuTable> 
                                                        </tr>
            
                                            } )
                                        }

                                </Fragment>                                
                            }


                        </tbody>
                </table>

            </div>
        }


        <div>
            <br/>
            <br/>
            <div className="calColor">Grafik - podsumowanie,  {filterParam.rok} - {filterParam.miesiac}  </div>
            <br/>

             <div className="table_widget">

                <HtmlToPDF tabRef={tab2RefPDF} userData={props.userData} mainView={props.mainView}  orientation="landscape" title="Rejestr" />   
                <Csv tabRef={tab2RefCSVPrint} />
                <Print tabRef={tab2RefCSVPrint} />

              </div>

            <div ref={tab2RefPDF} className="gohide">


            <div className="calColor">Grafik - podsumowanie  {filterParam.rok + "-" + filterParam.miesiac }</div>   



                    <div className="scorll_x">
                        <table className="table" ref={tab2RefCSVPrint}>
                                <thead>
                                    <tr className="header">
                                        <td className="td_left">LP</td>                        
                                        <td>Osoba</td>
                                        <td className="td_right">Łączny czas</td>
                                    </tr>
                                </thead>
                                <tbody>

                                    {
                                        tab.sum != undefined &&
                                        <Fragment>
                                                {
                                                    tab.sum.map( (row, inx) => {

                                                            var rowStyle = " row ";
                                                            if(inx % 2 == 0 )rowStyle = " row2 ";

                                                            return <tr key={inx} className={rowStyle}>

                                                                    <td className="gocenter">{inx+1}</td>
                                                                    <td>{row.nazwisko + " " +  row.imie}</td>                                            
                                                                    <td className="gocenter">{row.razem_czas}</td>
                                                            </tr>

                                                    } )
                                                }
                                        </Fragment>
                                    }

                                
                                </tbody>
                        </table>
                    </div>
                        
            </div>



        <div className="scorll_x">
            <table className="table">
                    <thead>
                        <tr className="header">
                            <td className="td_left">LP</td>                        
                            <td>Osoba</td>
                            <td className="td_right">Łączny czas</td>
                        </tr>
                    </thead>
                    <tbody>

                        {
                            tab.sum != undefined &&
                            <Fragment>
                                    {
                                        tab.sum.map( (row, inx) => {

                                                var rowStyle = " row ";
                                                if(inx % 2 == 0 )rowStyle = " row2 ";

                                                return <tr key={inx} className={rowStyle}>

                                                        <td className="gocenter">{inx+1}</td>
                                                        <td>{row.nazwisko + " " +  row.imie}</td>                                            
                                                        <td className="gocenter">{row.razem_czas}</td>
                                                </tr>

                                        } )
                                    }
                            </Fragment>
                        }

                       
                    </tbody>
            </table>
        </div>


        </div>



    </div>
}


export default Schedule;